import { Box, Text } from '@frameio/vapor';
import TEXT from './generated/TEXT/NoResultsMessage';

type NoResultsMessageProps = {
  query: string;
  title?: string;
  message?: string;
};

TEXT.DEFINE({
  /** Empty state title shown when no projects match the current search */
  searchEmptyState: 'No projects matching',
  /** Empty state text that displays the user's search query (wrapped in quotes) */
  searchEmptyStateQuery: (query: string) => `"${query}"`,
});

export const NoResultsMessage = ({
  query,
  title = TEXT.searchEmptyState,
  message = TEXT.searchEmptyStateQuery(query) as string,
}: NoResultsMessageProps) => (
  <Box
    alignItems="center"
    display="flex"
    flexDirection="column"
    left="50%"
    position="absolute"
    top="50%"
    transform="translate(-50%, -50%)"
    width="100%"
  >
    <Text color="tertiary" variant="body">
      {title}
    </Text>
    <Text variant="body">{message}</Text>
  </Box>
);
